<md-content-box class="container">
	<div>
		<md-icon icon="untitled-ui/maps/globe-06"></md-icon>
		<div class="timezone">
			<div class="header">Time Zone</div>
			<div>{{ timeZoneName() }}</div>
		</div>
	</div>

	<lb-divider></lb-divider>

	<div>
		<md-icon icon="untitled-ui/time/calendar"></md-icon>
		<div class="dates">
			<div class="header">Selected Start Date</div>
			<div>{{ startDate() }}</div>
		</div>
		<div class="dates">
			<div class="header">Anticipated End Date</div>
			<div>{{ endDate() }}</div>
		</div>
	</div>

	<lb-divider></lb-divider>

	<div>
		<md-icon icon="untitled-ui/education/book-open-01"></md-icon>
		<div class="lessons">
			<div class="header">Lesson Frequency</div>
			<md-content-box>{{ lessonsFrequency() }} lessons / week</md-content-box>
		</div>
	</div>

	<lb-divider></lb-divider>

	<div>
		<md-icon icon="untitled-ui/time/clock-check"></md-icon>
		<div class="times-review">
			<div class="header">Preferred Time</div>
			<div class="schedule-times">
				@for (selection of preferredTimeSlotSelections(); track $index) {
					<div class="schedule">
						<div>{{ selection.day }}</div>
						<div>
							<md-content-box class="time-blocks">
								@for (time of selection.times; track time) {
									<span class="time-block">{{ time }}</span>
								}
							</md-content-box>
						</div>
					</div>
				}
			</div>
		</div>
	</div>

	<lb-divider></lb-divider>

	<div>
		<md-icon icon="untitled-ui/time/clock"></md-icon>
		<div class="times-review">
			<div class="header">Preferred Time and Additional Availability</div>
			<div class="schedule-times">
				@for (selection of timeSlotSelections(); track $index) {
					<div class="schedule">
						<div>{{ selection.day }}</div>
						<div>
							<md-content-box class="time-blocks">
								@for (time of selection.times; track time) {
									<span class="time-block">{{ time }}</span>
								}
							</md-content-box>
						</div>
					</div>
				}
			</div>
		</div>
	</div>

	<lb-divider></lb-divider>

	<div>
		<md-icon icon="untitled-ui/general/bookmark"></md-icon>
		<div class="enrollment-notes-review">
			<div class="header">Details entered in the enrollment form are listed below. Please share any updates or additions.</div>
			<div class="enrollment-notes">
				<div class="note-field">
					<div class="notes-header">Language Experience</div>
					<div class="readonly">{{ readonlyLanguageExperience() }}</div>
					<lb-form-field>
						<textarea md-form-input [value]="languageExperience()" (input)="updateReviewField('languageExperience', $event)" rows="4"></textarea>
					</lb-form-field>
				</div>

				<div class="note-field">
					<div class="notes-header">Learning Needs</div>
					<div class="readonly">{{ readonlyLearningNeeds() }}</div>
					<lb-form-field>
						<textarea md-form-input [value]="learningNeeds()" (input)="updateReviewField('learningNeeds', $event)" rows="4"></textarea>
					</lb-form-field>
				</div>

				<div class="note-field">
					<div class="notes-header">Requested Instructor</div>
					<div class="readonly">{{ readonlyRequestedInstructor() }}</div>
					<lb-form-field>
						<textarea md-form-input [value]="requestedInstructor()" (input)="updateReviewField('requestedInstructor', $event)" rows="4"></textarea>
					</lb-form-field>
				</div>
			</div>
		</div>
	</div>
</md-content-box>
